import type { JournalItem } from "@nabla/api";

const arquivos = {
  registro: (nome: string, video: boolean, arquivo: string, conjunto: string) =>
    `${nome} enviou ${video ? "o vídeo" : "a imagem"} “${arquivo}” para um anúncio novo em ${conjunto}.`,
  registroDrive: (video: boolean, arquivo: string, pasta: string, conjunto: string) =>
    `A Nabla escolheu ${video ? "o vídeo" : "a imagem"} “${arquivo}” da pasta do Drive (${pasta}) para um anúncio novo em ${conjunto}.`,
};

export function journal(item: JournalItem, actor: string): string | undefined {
  if (item.type !== "arquivo") return undefined;
  const { kind, name, drive } = item.file;
  const where = item.object?.name ?? "";
  if (drive !== undefined) return arquivos.registroDrive(kind === "video", name, drive.join(" / "), where);
  return arquivos.registro(actor, kind === "video", name, where);
}
